// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree-detail-modal-content {
    /* Auto height by default, but we can add specific tree styles here if needed */
    border-radius: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ValidatorDelegator/TreeUserDetailModal.css"],"names":[],"mappings":"AAAA;IACI,+EAA+E;IAC/E,8BAA8B;AAClC","sourcesContent":[".tree-detail-modal-content {\n    /* Auto height by default, but we can add specific tree styles here if needed */\n    border-radius: 12px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
